/* jslint browser: true, vars: true, nomen: true, indent: 4, maxlen: 180, plusplus: true, sloppy: true */
/* global mdev: true,console: true, module: true ,require: true, AMap: true */
var $ = window.$;
var _ = window._;

var dlg = {
    layDom: [],
    wrapDom: [],
    changePos: function () {
        var dlgTop = ($(window).height() - dlg.wrapDom.height()) / 2;
        var dlgLeft = ($(window).width() - dlg.wrapDom.width()) / 2;
        dlg.wrapDom.css('top', dlgTop);
        dlg.wrapDom.css('left', dlgLeft);
    },
    close: function () {
        dlg.layDom.fadeOut('slow');
        dlg.wrapDom.fadeOut('slow');
    }
};

var cfloatDlg = function ($dom, option, fn) {
    if (dlg.layDom.length < 1) {
        dlg.layDom = $('<div class="cfloat-dlg-lay"></div>').appendTo($('body'));
        dlg.layDom.click(function () {
            dlg.close();
        });
        dlg.layDom.css({
            'background-color': 'rgb(0, 0, 0)',
            'opacity': '0.5',
            'cursor': 'pointer',
            'height': '7310px',
            'display': 'block',
            'position': 'fixed',
            'z-index': '9999999994',
            'width': '100%',
            'top': '0',
            'left': '0'
        });
    }

    // if (dlg.wrapDom.length < 1) {
    dlg.wrapDom = $('<div class="cfloat-dlg-wrap"></div>').appendTo($('body'));
    dlg.wrapDom.html($dom);
    dlg.wrapDom.css({
        'width': option.width,
        'position': 'fixed',
        'height': 'auto',
        'top': '89px',
        'left': '562px',
        'display': 'block',
        'z-index': '9999999995'
    });
    // dlg.wrapDom.find('.cfloat-dlg-close').click(function () {
    //     dlg.close();
    // });
    $(window).on('resize', function () {
        dlg.changePos();
    });
    // fn && fn();
    // }

    dlg.changePos();
    dlg.layDom.fadeIn('slow');
    dlg.wrapDom.fadeIn('slow');
    fn && fn(dlg);
};

module.exports = cfloatDlg;



// WEBPACK FOOTER //
// ./~/@front-end/common-module-vm/feedback-dialog/cf-dlg.js